
define('tmpl!core/templates/webidl-contiguous/field.html', ['deps/handlebars'], function (hb) { return hb.compile('<span class=\'idlField\' id="{{obj.idlId}}" data-idl data-title=\'{{obj.name}}\'>{{extAttr obj indent\n}}{{idn indent}}<span class=\'idlFieldType\'>{{idlType obj}}</span> {{pads\npad}}<span class=\'idlFieldName\'>{{#tryLink obj}}{{obj.name}}{{/tryLink}}</span>;</span>\n');});

